import { Link } from "react-router-dom";
import { HiMenuAlt2, HiMenuAlt1 } from "react-icons/hi";
import { useState } from "react";
import { getUserRole } from "../../../../../../../store/user.store";
import Roles from "../../../../../../../enum/Role";

export default function PaymentSideBar() {
  const [burgerToggle, setburgerToggle] = useState(false);
  const activeRole = getUserRole();
  /// Path
  let path = window.location.pathname;

  let superAdminMenuItems = [
    {
      path: "/payment/setup-configuration/payment-categories",
      children: ["/payment/setup-configuration/payment-categories"],
      label: "Payment Categories",
    },
    {
      path: "/payment/setup-configuration/bill-configuration",
      children: ["/payment/setup-configuration/bill-configuration"],
      label: "Bill Configuration",
    },
    {
      path: "/payment/setup-configuration/restritions-setup",
      children: ["/payment/setup-configuration/restritions-setup"],
      label: "Restrictions Setup",
    },
    {
      path: "/payment/setup-configuration/invoice-receipt-templates",
      children: [
        "/payment/setup-configuration/invoice-receipt-templates",
        "/payment/setup-configuration/templates-broad-view",
      ],
      label: "Invoice & Receipt Templates",
    },
    {
      path: "/payment/setup-configuration/invoice-receipt-setup",
      children: ["/payment/setup-configuration/invoice-receipt-setup"],
      label: "Invoice & Receipt Setup",
    },
    {
      path: "/payment/setup-configuration/settlement-setup",
      children: ["/payment/setup-configuration/settlement-setup"],
      label: "Settlements Setup",
    },
    {
      path: "/payment/setup-configuration/biller-entities",
      children: ["/payment/setup-configuration/biller-entities"],
      label: "Biller Entity",
    },
    {
      path: "/payment/setup-configuration/biller-groups",
      children: ["/payment/setup-configuration/biller-groups"],
      label: "Biller Entity Groups",
    },
    {
      path: "/payment/setup-configuration/settlement-accounts",
      children: ["/payment/setup-configuration/settlement-accounts"],
      label: "Settlement accounts",
    },
    {
      path: "/payment/setup-configuration/bill-aggregation",
      children: ["/payment/setup-configuration/bill-aggregation"],
      label: "Bill Aggregation",
    },
  ];

  let managerMenuItems = [
    {
      path: "/payment/setup-configuration/bill-configuration",
      children: ["/payment/setup-configuration/bill-configuration"],
      label: "Bill Configuration",
    },
    {
      path: "/payment/setup-configuration/invoice-receipt-setup",
      children: ["/payment/setup-configuration/invoice-receipt-setup"],
      label: "Invoice & Receipt Setup",
    },
    {
      path: "/payment/setup-configuration/settlement-accounts",
      children: ["/payment/setup-configuration/settlement-accounts"],
      label: "Settlement accounts",
    },
  ];

  let clusterManagerMenuItems = [
    {
      path: "/payment/setup-configuration/bill-configuration",
      children: ["/payment/setup-configuration/bill-configuration"],
      label: "Bill Configuration",
    },
    {
      path: "/payment/setup-configuration/settlement-accounts",
      children: ["/payment/setup-configuration/settlement-accounts"],
      label: "Settlement accounts",
    },
  ];

  const menu =
    activeRole === Roles.Admin
      ? superAdminMenuItems
      : activeRole === Roles.EstateManager
      ? managerMenuItems
      : activeRole === Roles.TribeManager
      ? managerMenuItems
      : activeRole === Roles.ClusterManager
      ? clusterManagerMenuItems
      : [];

  return (
    <div className="tw-sticky tw-top-0 tw-h-full tw-w-full tw-rounded-lg tw-bg-[#F6F6F6] tw-pt-8  lg:tw-h-screen">
      <div className="px-3 tw-flex tw-items-center tw-justify-between">
        <p className=" tw-whitespace-nowrap tw-text-2xl tw-text-primary-dark-text xl:tw-text-[32px]">
          Setup & Config
        </p>
        <div className="tw-inline lg:tw-hidden">
          {burgerToggle ? (
            <HiMenuAlt1
              size={25}
              className=" cursor-pointer tw-text-primary-dark-text"
              onClick={() => setburgerToggle(false)}
            />
          ) : (
            <HiMenuAlt2
              size={25}
              onClick={() => setburgerToggle(true)}
              className=" cursor-pointer tw-text-primary-dark-text"
            />
          )}
        </div>
      </div>
      <div
        className={`${
          !burgerToggle ? "tw-hidden" : "lg:tw-hidden"
        } tw-mt-[20px] tw-space-y-3 `}
      >
        {menu.map((item, index) => (
          <div
            key={index}
            className={`${
              item.children.includes(path)
                ? "font-w500  tw-border-r-4 tw-border-r-primary-blue tw-text-primary-blue "
                : ""
            }`}
          >
            <Link to={item.path}>
              <span className=" ml-3 font-w500 tw-text-xs lg:tw-text-sm">
                {item.label}
              </span>
            </Link>
          </div>
        ))}
      </div>
      <div
        className={`tw-ml-4 tw-mt-[30px] tw-hidden tw-space-y-3 lg:tw-block`}
      >
        {menu.map((item, index) => (
          <div
            key={index}
            className={`${
              item.children.includes(path)
                ? "tw-border-r-4  tw-border-r-primary-blue tw-text-primary-blue"
                : ""
            }`}
          >
            <Link to={item.path}>
              <span className=" ml-3 font-w500 tw-text-xs lg:tw-text-sm">
                {item.label}
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
